import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

export default function AdminLogin() {
  const [pw, setPw] = useState('');
  const [err, setErr] = useState('');
  const nav = useNavigate();

  const login = () => {
    if (pw === process.env.REACT_APP_ADMIN_PASSWORD) {
      sessionStorage.setItem('sapan_admin', '1');
      nav('/admin');
    } else {
      setErr('Password salah');
    }
  };

  return (
    <div style={{ minHeight: '100vh', background: 'var(--sand)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20 }}>
      <div style={{ background: 'var(--paper)', border: '1px solid var(--line)', borderRadius: 16, padding: '36px 32px', width: '100%', maxWidth: 360, textAlign: 'center', boxShadow: 'var(--store-shadow)' }}>
        <div style={{ fontFamily: "'Baloo 2',sans-serif", fontWeight: 700, fontSize: '1.6rem', color: 'var(--ink)', marginBottom: 4 }}>HAPin</div>
        <div style={{ fontFamily: "'DM Mono', monospace", fontSize: '.65rem', letterSpacing: '2px', color: 'var(--primary)', textTransform: 'uppercase', marginBottom: 28 }}>Admin Panel</div>
        <input
          type="password" placeholder="Password" value={pw}
          onChange={e => { setPw(e.target.value); setErr(''); }}
          onKeyDown={e => e.key === 'Enter' && login()}
          style={{ width: '100%', background: 'var(--sand)', border: '1.5px solid var(--line)', borderRadius: 8, padding: '10px 14px', color: 'var(--ink)', fontSize: '.9rem', marginBottom: 12, outline: 'none', boxSizing: 'border-box' }}
        />
        {err && <div style={{ color: '#B23A15', fontSize: '.78rem', marginBottom: 10 }}>{err}</div>}
        <button onClick={login} style={{ width: '100%', padding: '10px', borderRadius: 8, background: 'var(--primary)', color: '#fff', border: 'none', fontSize: '.9rem', fontWeight: 700, fontFamily: "'DM Sans', sans-serif", cursor: 'pointer' }}>
          Masuk
        </button>
      </div>
    </div>
  );
}
